import { tv } from "@opensea/ui-kit"

export const collectionInfoVariants = tv({
  slots: {
    avatar: "max-h-[46px] max-w-[46px] rounded",
    itemContent: "gap-1 overflow-visible",
  },
  variants: {
    headerView: {
      full: "",
      compact: "",
    },
  },
  compoundVariants: [
    {
      headerView: "full",
      class: {
        avatar: "max-h-[60px] max-w-[60px]",
      },
    },
  ],
})
